function applyCorrectFocus() {
  const hash = window.location.hash;

  if (hash === "#recover") {
    document.querySelector("#RecoverEmail")?.focus();
  } else {
   
    const customerEmail = document.querySelector('#CustomerEmail');
    customerEmail?.focus();

  }
}

window.addEventListener("load", applyCorrectFocus);
window.addEventListener("hashchange", applyCorrectFocus);
